export default __webpack_public_path__ + "static/media/2.1385d904.png";